import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, createStyles, Icon, TFText, Tooltip } from '@tf/ui';
import type React from 'react';

const useStyles = createStyles(({ colors, radius }) => ({
	wrapper: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '.25rem .75rem',
		borderRadius: radius.sm,
		backgroundColor: colors.gray[1],
		marginTop: '.5rem',
		'& :not(:first-of-type)': {
			marginTop: '0',
		},
	},
	content: {
		flex: 1,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		marginRight: '.5rem',
	},
}));

interface FileListProps {
	files: File[];
	onDelete: (file: File) => void;
}

export const FileList: React.FC<FileListProps> = ({ files, onDelete }) => {
	const { _ } = useLingui();
	const { classes } = useStyles();

	return (
		<>
			<TFText m="1.5rem 0 .5rem 0" size="md" fw="600">
				Attached files:
			</TFText>
			{files.map((file, index) => (
				<Box key={index} className={classes.wrapper}>
					<Box className={classes.content}>{file.name}</Box>
					<Box>
						<Tooltip label={_(msg({ id: 'caseRequestPage.deleteFileTooltip', message: 'Delete file' }))} withArrow>
							<ActionIcon variant="subtle" color="red" onClick={() => onDelete(file)}>
								<Icon.IconTrash size={18} stroke={1.5} />
							</ActionIcon>
						</Tooltip>
					</Box>
				</Box>
			))}
		</>
	);
};
